import { useEffect, useRef } from "react";
import cc from "classcat";
import {
  useIsSidebarEnabled,
  useSidebarContainer
} from "../../src/modules/sidebar/sidebar.hooks";
import styles from "./SubDrawer.module.scss";

type SubDrawerProps = {
  children: React.ReactNode;
  isOpen: boolean;
};

const SubDrawer = ({ children, isOpen }: SubDrawerProps) => {
  const { isCollapsed: isSidebarCollapsed } = useSidebarContainer();
  const contentRef = useRef<HTMLDivElement>(null);
  const { isSidebarEnabled } = useIsSidebarEnabled();
  const isSidebarExpanded = isSidebarEnabled && !isSidebarCollapsed;
  useEffect(() => {
    let previousBodyOverflow = "";
    let previousHtmlOverflow = "";

    if (isOpen) {
      previousBodyOverflow = document.body.style.overflow;
      previousHtmlOverflow = document.documentElement.style.overflow;

      window.scrollTo({ top: 0, behavior: "auto" });
      contentRef.current?.scrollTo({ top: 0, behavior: "auto" });

      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }

    return () => {
      if (!isOpen) {
        return;
      }

      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [isOpen]);

  return (
    <div
      className={cc([
        styles["sub-drawer"],
        { [styles.sidebarExpanded]: isSidebarExpanded },
        isOpen && styles["sub-drawer--open"],
        isOpen &&
          isSidebarCollapsed &&
          styles["sub-drawer--open--sidebar-collapsed"]
      ])}
    >
      <div ref={contentRef} className={cc([styles["sub-drawer-content"]])}>
        {children}
      </div>
    </div>
  );
};

export default SubDrawer;
